export function getScrollDirection(pointerY, containerRect, threshold = 60) {
  if (pointerY < containerRect.top || pointerY > containerRect.bottom) return null;
  if (pointerY > containerRect.bottom - threshold) return 'down';
  if (pointerY < containerRect.top + threshold) return 'up';
  return null;
}

export function canScrollInDirection(container, direction) {
  if (direction === 'down') return container.scrollTop < container.scrollHeight - container.clientHeight - 1;
  if (direction === 'up') return container.scrollTop > 0;
  return false;
}
